export const getDomainName = (hostName) => {
    if (hostName.lastIndexOf(':') > -1) {
        hostName = hostName.substring(0, hostName.lastIndexOf(':'));
    }
    return hostName.substring(hostName.indexOf('.', hostName.indexOf('.') - 1) + 1);
};

export const getCookie = (key) => {
    const arr = document.cookie.match(new RegExp(`(^| )${key}=([^;]*)(;|$)`));
    return (arr != null) ? decodeURI(arr[2]) : null;
};

export const setCookie = (key, value, exdays) => {
    const host = getDomainName(window.location.host);
    const d = new Date();
    const exps = exdays || 365;
    d.setTime(d.getTime() + (exps * 24 * 60 * 60 * 1000));
    const expires = `expires=${d.toGMTString()}`;
    const domain = `${host === 'localhost' ? '' : '.'}${host}`;
    const command = `${key}=${value}; ${expires}; path=/; domain=${domain}`;
    document.cookie = command;
};

export const delCookie = (key) => {
    const host = getDomainName(window.location.host);
    const d = new Date();
    const expires = `expires=${d.toGMTString()}`;
    const domain = `${host === 'localhost' ? '' : '.'}${host}`;
    const command = `${key}=; ${expires}; path=/; domain=${domain}`;
    document.cookie = command;
};

export const getCookie2 = (cname) => {
    const name = `${cname}=`;
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i += 1) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return '';
};
